<template>
  <section>
    <div
      v-if="verificationFailed"
      class="fail-message-style mb-4"
    >
      <p class="fail-style">
        <v-icon
          color="#C62828"
          size="30"
        >
          mdi-alert
        </v-icon> <br>
        {{ verificationFailedMessage }}
      </p>
    </div>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card-title>
          <p class="process-header mb-0">
            Select work type
          </p>
        </v-card-title>
        <v-card-text>
          <v-radio-group
            v-model="workType"
            row
            light
            class="radio-group-style"
            :rules="[(v) => !!v || 'This field is required']"
            @change="isWorkTypeChanged"
          >
            <v-radio
              label="Construction Work"
              value="project-work"
              light
              class="value-text-style"
              color="#37474F"
            >
              <template #label>
                <p class="type-bottom">
                  Project
                </p>
              </template>
            </v-radio>
            <v-radio
              label="Issue Fix"
              value="project-issue"
              class="value-text-style"
              light
              color="#37474F"
            >
              <template #label>
                <p class="type-bottom">
                  Issue
                </p>
              </template>
            </v-radio>
          </v-radio-group>
          <v-container fluid>
            <div v-if="isBudgetTypeSelected">
              <v-autocomplete
                v-model="selectedBudgetItem"
                :items="projectBudgets"
                item-value="id"
                color="#37474F"
                filled
                outlined
                dense
                class="field-text-style"
                light
                item-text="name"
                :rules="[(v) => !!v || 'This field is required']"
                label="Select Work Item"
                prepend-icon="mdi-account-hard-hat"
                hint="Select your work item from the available list for continuing the check-in process."
                persistent-hint
                @input="getSelectedBudgetDetails()"
              />
            </div>
            <div v-if="isIssueTypeSelected">
              <v-autocomplete
                v-model="selectedProjectIssue"
                :items="projectIssues"
                item-value="id"
                color="#37474F"
                filled
                outlined
                dense
                class="field-text-style"
                light
                item-text="title"
                :rules="[(v) => !!v || 'This field is required']"
                label="Select Issue"
                prepend-icon="mdi-tools"
                hint="Select a project issue from this available list for continuing the check-in process."
                persistent-hint
                @input="getSelectedIssueDetails()"
              />
            </div>
            <div
              v-if="isWorkItemSelected"
              class="details-div"
            >
              <p class="title-text-style">
                Description: <font
                  v-if="selectedWorkDetails.details.description !== null"
                  class="value-text-style"
                >
                  {{ selectedWorkDetails.details.description }}
                </font><font
                  v-else
                  class="value-text-style"
                >
                  N/A
                </font>
              </p>
              <p class="title-text-style">
                High Risk Work:- <font
                  class="status-format"
                  :color="getHrwColor(selectedWorkDetails.details.high_risk_work)"
                >
                  {{ selectedWorkDetails.details.high_risk_work | displayHighRisk }}
                </font>
              </p>
              <p class="title-text-style">
                Status: <font
                  v-if="selectedWorkDetails.details.status !== null"
                  class="status-format"
                  :color="getStatusColor(selectedWorkDetails.details.status)"
                >
                  {{ selectedWorkDetails.details.status | statusFormat }}
                </font>
                <font
                  v-else
                  class="value-text-style"
                >
                  N/A
                </font>
              </p>
              <br>
            </div>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
    <v-btn
      color="#000"
      class="mt-5 btn-style"
      elevation="0"
      :light="locationFetchFailed"
      :disabled="locationFetchFailed"
      @click="verifyWorkDetails()"
    >
      Next
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
    <budget-instances
      v-if="showInstancesForm"
      @store-instance="saveInstanceDetails"
      @closed="showInstancesForm = false"
    />
  </section>
</template>

  <script>
  import spinner from 'src/views/components/SpinnerCentre';
  import Constants from 'src/constants';
  import BudgetInstances from './BudgetInstances.vue';

  export default {
    name: 'GatherWorkDetails',
    components: {
      'centre-spinner': spinner,
      'budget-instances': BudgetInstances,
    },
    filters: {
      arrangePretty (val) {
        return val.join(', ');
      },
      displayHighRisk (status) {
        if (status === true) {
          return 'Yes*';
        } else {
          return 'No';
        }
      },
      statusFormat (val) {
        if (val === 'active') {
          return 'Active*';
        } else if (val === 'pending') {
          return 'Pending';
        } else if (val === 'completed') {
          return 'Completed*';
        } else {
          return val;
        }
      },
    },
    data: () => ({
      workType: '',
      selectedBudgetItem: '',
      loading: false,
      valid: false,
      verificationFailed: false,
      verificationFailedMessage: '',
      isBudgetTypeSelected: false,
      selectedProjectIssue: '',
      isIssueTypeSelected: false,
      showInstancesForm: false,
      locationFetchFailed: false,
    }),
    computed: {
      userDetails () {
        return this.$store.getters.getUser;
      },
      locationName () {
        return this.$store.getters['swiftuser/getLocationName'];
      },
      projectBudgets () {
        return this.$store.getters['projects/getProjectBudgets'];
      },
      selectedWorkDetails () {
        return this.$store.getters['swiftuser/getSelectedWorkDetails'];
      },
      isWorkItemSelected () {
        if (Object.keys(this.selectedWorkDetails).length > 0) {
          return true;
        }
        return false;
      },
      projectIssues () {
        return this.$store.getters['projects/getProjectIssues'];
      },
      budgetInstances () {
        return this.$store.getters['projects/getBudgetInstances'];
      },
      selectedOrganization () {
        return this.$store.getters['organization/getSelectedOrganization'];
      },
      selectedOrgProject () {
        return this.$store.getters['projects/getSelectedOrgProject'];
      },
      selectedOrgProjectGate () {
        return this.$store.getters['projects/getSelectedOrgProjectGate'];
      },
    },
    async mounted () {
      await this.fetchProjectBudgets();
      await this.fetchProjectIssues();
      this.$store.dispatch('swiftuser/clearSavedWorkDetails');
    },
    methods: {
      async fetchProjectBudgets (projectid) {
        this.loading = true;
        await this.$store.dispatch('projects/fetchProjectBudgets', {
          projectId: this.locationName.project.id,
        });
        this.loading = false;
      },
      async getSelectedBudgetDetails () {
        this.loading = true;
        const budgetDetails = this.projectBudgets.find(
          budget => budget.id === this.selectedBudgetItem,
        );
        await this.$store.dispatch('swiftuser/saveSelectedWorkDetails', {
          details: budgetDetails,
          workType: 'project-work',
        });
        this.loading = false;
      },
      async fetchProjectIssues () {
        this.loading = true;
        await this.$store.dispatch('projects/fetchProjectIssues', {
          paramData: {
            params: {
             status: ['pending', 'active'],
          },
          },
          projectId: this.locationName.project.id,
        });
        this.loading = false;
      },
      async getSelectedIssueDetails () {
        this.loading = true;
        const issueDetails = this.projectIssues.find(
          issue => issue.id === this.selectedProjectIssue,
        );
        await this.$store.dispatch('swiftuser/saveSelectedWorkDetails', {
          details: issueDetails,
          workType: 'project-issue',
        });
        this.loading = false;
      },
      async verifyWorkDetails () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please select the work before proceeding to next step.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        if (this.workType === 'project-work') {
          await this.$store.dispatch('swiftuser/verifyWorkDetails', {
            organizationExtId: this.selectedOrganization.organization.external_id,
            details: {
              type: 'project-work',
              budget_id: this.selectedBudgetItem,
              issue_id: null,
            },
        }).then(response => {
          this.getBudgetInstances();
        }).catch(error => {
            this.loading = false;
            this.verificationFailed = true;
            this.verificationFailedMessage = error.response.data.message;
          });
        return;
        }
        await this.$store.dispatch('swiftuser/verifyWorkDetails', {
          organizationExtId: this.selectedOrganization.organization.external_id,
          details: {
            type: 'project-issue',
            issue_id: this.selectedProjectIssue,
            budget_id: null,
          },
        }).then(response => {
          this.loading = false;
          this.$emit('work-details-stored');
        }).catch(error => {
          this.loading = false;
          this.verificationFailed = true;
          this.verificationFailedMessage = error.response.data.message;
        });
      },
      async getBudgetInstances () {
        await this.$store.dispatch('projects/fetchBudgetInstances', {
          budgetId: this.selectedBudgetItem,
        }).then(response => {
          if (this.budgetInstances.length === 1) {
            const instanceId = this.budgetInstances[0].id;
            this.$store.dispatch('swiftuser/saveSelectedInstanceDetails', instanceId);
            this.loading = false;
            this.$emit('work-details-stored');
          } else if (this.budgetInstances.length > 1) {
            this.loading = false;
            this.showInstancesForm = true;
          } else {
            this.loading = false;
            this.$emit('work-details-stored');
          }
        }).catch(error => {
          this.loading = false;
          this.verificationFailed = true;
          this.verificationFailedMessage = error.response.data.message;
        });
      },
      saveInstanceDetails (instanceId) {
        this.loading = true;
        setTimeout(() => {
          this.$store.dispatch('swiftuser/saveSelectedInstanceDetails', instanceId);
          this.loading = false;
          this.$emit('work-details-stored');
        }, 1000);
      },
      cancel () {
        this.loading = true;
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
        setTimeout(() => {
          this.$router.push({ name: 'CheckIn' });
        }, 1000);
      },
      isWorkTypeChanged () {
        this.$store.dispatch('swiftuser/clearSavedWorkDetails');
        if (this.workType === 'project-work') {
          this.isIssueTypeSelected = false;
          this.selectedProjectIssue = '';
          this.isBudgetTypeSelected = true;
        } else {
          this.isBudgetTypeSelected = false;
          this.selectedBudgetItem = '';
          this.isIssueTypeSelected = true;
        }
      },
      getHrwColor (value) {
        if (value === true) return '#C62828';
        else { return '#2E7D32'; }
      },
      getStatusColor (val) {
        if (val === 'active') {
          return '#2E7D32';
        } else if (val === 'pending') {
          return '#C62828';
        } else if (val === 'completed') {
          return '#FF3700';
        } else {
          return '#EF6C00';
        }
      },
    },
  };
</script>
<style scoped>
.status-format {
  text-transform: capitalize;
}
.type-bottom{
  margin-bottom: 0px;
}
.theme--dark.v-list{
  background-color: white!important;
}
.theme--dark >>> .v-list-item{
  color:#37474F!important;
}
.checkin .mdi-checkbox-marked::before{
  color: #37474F !important;
  caret-color: #37474F !important;
}
::v-deep .v-input--selection-controls__input .v-icon {
  color: #37474F !important;
}
</style>
